(()=>{
  const $=id=>document.getElementById(id);
  const select=$('dcs-location'),clock=$('dcs-local-time');
  if(!select||!clock)return;
  const cities={
    'London, UK':[51.5074,-.1278],'Birmingham, UK':[52.4862,-1.8904],
    'Manchester, UK':[53.4808,-2.2426],'Leeds, UK':[53.8008,-1.5491],
    'Liverpool, UK':[53.4084,-2.9916],'Sheffield, UK':[53.3811,-1.4701],
    'Nottingham, UK':[52.9548,-1.1581],'Leicester, UK':[52.6369,-1.1398],
    'Derby, UK':[52.9225,-1.4746],'Stoke-on-Trent, UK':[53.0027,-2.1794],
    'Wolverhampton, UK':[52.587,-2.1288],'Bristol, UK':[51.4545,-2.5879],
    'Bath, UK':[51.3758,-2.3599],'Gloucester, UK':[51.8642,-2.2382],
    'Cheltenham, UK':[51.8994,-2.0783],'Exeter, UK':[50.7184,-3.5339],
    'Plymouth, UK':[50.3755,-4.1427],'Truro, UK':[50.2632,-5.051],
    'Oxford, UK':[51.752,-1.2577],'Cardiff, UK':[51.4816,-3.1791],
    'Edinburgh, UK':[55.9533,-3.1883],'Belfast, UK':[54.5973,-5.9301]
  };
  const write=(id,text)=>{const el=$(id);if(el)el.textContent=text};
  const valid=d=>d instanceof Date&&Number.isFinite(d.getTime());
  const format=(date,tz,seconds=false)=>new Intl.DateTimeFormat('en-GB',{hour:'2-digit',minute:'2-digit',...(seconds?{second:'2-digit'}:{}),timeZone:tz}).format(date);
  const day=(date,tz)=>new Intl.DateTimeFormat('en-CA',{year:'numeric',month:'2-digit',day:'2-digit',timeZone:tz}).format(date);
  let site=null,events=[],sunset=null,cachedDay='';
  const old=select.value;select.textContent='';
  Object.keys(cities).forEach(name=>{const o=document.createElement('option');o.value=name;o.textContent=name;select.appendChild(o)});
  select.value=cities[old]?old:'London, UK';
  function calculate(now){
    cachedDay=day(now,site.tz);events=[];sunset=null;
    const engine=window.SunCalc;if(!engine?.getTimes)return;
    for(let offset=-2;offset<=2;offset++){
      const times=engine.getTimes(new Date(now.getTime()+offset*86400000),site.lat,site.lon);
      for(const type of ['sunrise','sunset'])if(valid(times[type])){events.push({type,date:times[type]});if(type==='sunset'&&day(times[type],site.tz)===cachedDay)sunset=times[type]}
    }
    events.sort((a,b)=>a.date-b.date);
  }
  function tick(){
    if(!site)return;const now=new Date();clock.textContent=format(now,site.tz,true);
    if(day(now,site.tz)!==cachedDay)calculate(now);
    if(!window.SunCalc?.getTimes){write('dcs-sunset-time','—');write('dcs-sunset-countdown','—');write('dcs-sunset-status','Solar times unavailable');return}
    const past=events.filter(e=>e.date<=now).pop();
    const above=past?past.type==='sunrise':window.SunCalc.getPosition(now,site.lat,site.lon).altitude>0;
    write('dcs-sunset-status',above?'Sun above horizon':'Sun below horizon');
    if(!sunset){write('dcs-sunset-time','No sunset today');write('dcs-sunset-countdown','—');return}
    write('dcs-sunset-time',format(sunset,site.tz));
    const seconds=Math.max(0,Math.floor((sunset-now)/1000));
    write('dcs-sunset-countdown',[Math.floor(seconds/3600),Math.floor(seconds%3600/60),seconds%60].map(n=>String(n).padStart(2,'0')).join(':'));
  }
  function updateByCoords(lat,lon,tz){
    if(!Number.isFinite(lat)||!Number.isFinite(lon)||Math.abs(lat)>90||Math.abs(lon)>180)return false;
    try{format(new Date(),tz)}catch(e){tz='UTC'}
    site={lat:Math.round(lat*100)/100,lon:Math.round(lon*100)/100,tz};cachedDay='';write('dcs-tz-pill',tz);tick();return true;
  }
  function choose(){const c=cities[select.value];if(c)updateByCoords(c[0],c[1],'Europe/London')}
  select.addEventListener('change',choose);
  const gps=$('dcs-use-location');
  gps?.addEventListener('click',()=>{
    if(!navigator.geolocation){gps.textContent='Location unavailable';return}
    gps.disabled=true;gps.textContent='Locating…';
    const reset=()=>{gps.disabled=false;gps.textContent='Use my location'};
    navigator.geolocation.getCurrentPosition(pos=>{
      const lat=Math.round(pos.coords.latitude*100)/100,lon=Math.round(pos.coords.longitude*100)/100;
      if($('dcs-custom-lat'))$('dcs-custom-lat').value=lat.toFixed(2);
      if($('dcs-custom-lon'))$('dcs-custom-lon').value=lon.toFixed(2);
      select.value='';updateByCoords(lat,lon,Intl.DateTimeFormat().resolvedOptions().timeZone||'UTC');reset();
    },()=>{reset();gps.textContent='Location unavailable — retry'},{enableHighAccuracy:false,timeout:10000,maximumAge:60000});
  });
  choose();setInterval(tick,1000);
})();
